<template>
    <div v-if="metricsEnabled">
        <component
            v-for="type in Object.entries(groupedMetrics)"
            :is="components[type[0]]"
            :metrics="type[1]"
        />
    </div>
</template>

<script setup>
import {defineAsyncComponent, ref} from 'vue';
import useTargetMetrics from '../../composables/useTargetMetrics';

const props = defineProps({
    metricsTool: {
        type: Object,
        default: () => {},
    },
    isPreviewResult: {
        type: Boolean,
        default: false,
    },
});

const components = {
  'yandex': defineAsyncComponent(() => import('./yandexMetricsRenderer.vue')),
  'googleAnalytics': defineAsyncComponent(() => import('./googleAnalyticsRenderer.vue')),
  'googleTags': defineAsyncComponent(() => import('./googleTagsManagerRenderer.vue')),
  'facebookPixel': defineAsyncComponent(() => import('./facebookPixelRenderer.vue')),
  'vkPixel': defineAsyncComponent(() => import('./vkPixelRenderer.vue')),
  'tiktokPixel': defineAsyncComponent(() => import('./tiktokPixelRenderer.vue')),

};

const yandexMetrics = ref([]);
const vkMetrics = ref([]);

const metricsEnabled = props.metricsTool.enabled ?? false;
const metrics = props.metricsTool.metrics ?? [];

const keyMap = {
  yandex_metrica: 'yandex',
  google_analytics: 'googleAnalytics',
  google_tag_manager: 'googleTags',
  facebook_pixel: 'facebookPixel',
  vk_pixel: 'vkPixel',
  tiktok_pixel: 'tiktokPixel',
};

const groupedMetrics = metrics.reduce((metricsByType, metric) => {
  const key = keyMap[metric.key] || null;
  if (key) {
    if (!metricsByType[key]) {
      metricsByType[key] = [];
    }
    metricsByType[key].push(metric);
  }
  return metricsByType;
}, {});


yandexMetrics.value = metrics.filter(metric => metric.key === 'yandex_metrica');
vkMetrics.value = metrics.filter(metric => metric.key === 'vk_pixel');

useTargetMetrics(yandexMetrics.value, vkMetrics.value);

</script>
